import {MenuContainer, StyledLink, MobileMenuHeader, MobileContainer, MobileBackground, MobileWrapper, StyledMobileLink} from "./style"
import {BurgerMenuIcon, CloseMenuIcon, MainLogoWithTextIcon} from "../../shared/assets/Svg";
import { Flex, Box, Button } from "../../shared/uikit";
import {useTranslation} from 'react-i18next';
import {LangSelector} from "../../widgets/LangSelector";
import {useMatchBreakpoints} from "../../shared/lib/hooks";
import {useState} from "react";

const links = [
  { title: 'nav.platform', anchor: '#platform' },
  { title: 'nav.how', anchor: '#how' },
  { title: 'nav.developers', anchor: '#developers' },
  { title: 'nav.faq', anchor: '#faq' },
]

const Menu = () => {

  const {t} = useTranslation()
  const {isMobile, isTablet} = useMatchBreakpoints()
  const isSmall = isMobile || isTablet

  const [menuIsOpen, setMenuIsOpen] = useState(false)

  return (
    <>
      {
        !isSmall
          ? <MenuContainer>
            <MainLogoWithTextIcon/>
            <Flex>
              {
                links.map((link) => (
                  <StyledLink href={link.anchor} key={link.anchor}>
                    {t(link.title)}
                  </StyledLink>
                ))
              }
            </Flex>
            <Flex alignItems='center'>
              <LangSelector/>
              <Flex height='42px' width='170px' ml='16px'>
                <a href='#hero' style={{width: '100%', height:'100%'}}>
                  <Button variant='outlined'>
                    {t('nav.cta')}
                  </Button>
                </a>
              </Flex>
            </Flex>
          </MenuContainer>
          :<>
            <MobileMenuHeader>
              <MainLogoWithTextIcon width='95px'/>
              <Flex alignItems='center'>
                <Box onClick={() => setMenuIsOpen(!menuIsOpen)} ml='20px' pr='8px'>
                  {!menuIsOpen ? <BurgerMenuIcon /> : <CloseMenuIcon />}
                </Box>
              </Flex>
            </MobileMenuHeader>
            <MobileContainer isOpen={menuIsOpen}>
              <MobileBackground isOpen={menuIsOpen} />
              <MobileWrapper>
                {
                  links.map((link) => (
                    <StyledMobileLink
                      href={link.anchor}
                      key={link.anchor}
                      onClick={() => setMenuIsOpen(false)}
                    >
                      {t(link.title)}
                    </StyledMobileLink>
                  ))
                }
                <Flex mb='30px'>
                  <LangSelector/>
                </Flex>
                <Flex height='42px' width='calc(100vw - 62px)'>
                  <a href='#hero' style={{width: '100%', height:'100%'}} onClick={() => setMenuIsOpen(false)}>
                    <Button variant='outlined'>
                      {t('nav.cta')}
                    </Button>
                  </a>
                </Flex>
              </MobileWrapper>
            </MobileContainer>
          </>
      }
    </>
  )
}

export default Menu
